import React from "react";

const partners = [
  {
    title: "Institutional Partners",
    items: [
      { name: "mdjs", link: "https://mdjs.ma" }
    ]
  },
  {
    title: "Gold Sponsor",
    items: [
      { name: "force-emploi", link: "https://www.forcemploi.ma/" }
    ]
  },
  {
    title: "Bronze sponsor",
    items: [
      { name: "badea-logo", link: "https://www.badea.org/" }
    ]
  },
  {
    title: "Premium Sponsor",
    items: [
      { name: "ingelec", link: "https://ingelec.ma" }
    ]
  },
  {
    title: "Scientific Partner",
    items: [
      { name: "positive_agenda", link: "https://positive-agenda.com" }
    ]
  },
  {
    title: "Sponsors & Partners",
    items: [
      { name: "icesco", link: "https://icesco.org" },
      { name: "ascame", link: "https://www.ascame.org/" },
      { name: "pacci", link: "https://www.pacci.org/" },
      { name: "africa_prosperity", link: "https://africaprosperitynetwork.com/" },
      { name: "football_agency", link: "https://4football-agency.com/" },
      { name: "aces", link: "https://www.acdsports.org/" },
      { name: "new_world", link: "https://www.newworldtv.com/" },
      { name: "maroc_academie", link: "https://trainingacademie.ma/" },
      { name: "akm", link: "https://akm-technologies.fr/" },
      { name: "pernova", link: "https://pernova.ma/" },
      { name: "prodige_event", link: "https://www.prodigevent.com/" },
      { name: "apsem", link: "https://www.entreprisesportive.ma/fr/" },
      { name: "frmje", link: "https://frmje.ma/" }
    ]
  },
  {
    title: "Media Partners",
    items: [
      { name: "afrique_matchs", link: "https://afriquematchs.com/" },
      { name: "financial_afrik", link: "https://www.financialafrik.com/" },
      { name: "diapason", link: "https://diapason.com" },
      { name: "tel_sports", link: "https://telsport.telquel.ma/" }
    ]
  }
];

export default function PartnersSection() {
  return (
    <section style={styles.section}>
      {partners.map(group => (
        <div key={group.title} style={styles.group}>
          <h2 style={styles.title}>{group.title}</h2>

          <div style={styles.grid}>
            {group.items.map(partner => (
              <div key={partner.name} style={styles.card}>
                <a href={partner.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={`/2026_partners/${partner.name}.png`}
                    alt={partner.name}
                    style={styles.logo}
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
      ))}
      <div style={{ textAlign: "center", marginTop: 48 }}>
        <a
          href="mailto:sponsoring@africamedforum.com"
          style={{
            display: "inline-block",
            background: "#FBBF24",
            color: "#000",
            fontWeight: 600,
            fontSize: 18,
            padding: "16px 36px",
            borderRadius: 8,
            textDecoration: "none",
            boxShadow: "0 4px 16px rgba(212,175,55,0.15)",
            transition: "background 0.2s, color 0.2s"
          }}
        >
          Join Our Sponsors
        </a>
      </div>
    </section>
  );
}

const styles = {
  section: {
    backgroundColor: "#000000",
    padding: "80px 24px",
    color: "#FBBF24"
  },
  group: {
    marginBottom: "64px",
    textAlign: "center"
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "32px",
    color: "#FBBF24",
    letterSpacing: "1px"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "32px",
    alignItems: "center",
    justifyItems: "center"
  },
  card: {
    backgroundColor: "#0A0A0A",
    borderRadius: "12px",
    padding: "24px",
    width: "100%",
    maxWidth: "220px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 8px 24px rgba(212,175,55,0.15)"
  },
  logo: {
    maxWidth: "100%",
    maxHeight: "90px",
    objectFit: "contain"
      ,
      borderRadius: "5px"
    }
};
